var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.$route.query.id == 1)?_c('PasswordForgot'):_vm._e(),(this.$route.query.id == 2)?_c('PasswordSent'):_vm._e(),(this.$route.query.id == 3)?_c('PasswordNew'):_vm._e(),(this.$route.query.id == 4)?_c('PasswordResetSuccess'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }